<script lang="ts">
	import { clickOutside } from './../../../../../../../../../helpers/index.js'
  import { onMount } from 'svelte'
  import { sliceItems } from '../../../../services'

  export let moreItems: string[]

  let firstPart = []
  let lastPart = []
  let isShowMoreItems = false

  onMount(() => {
    [firstPart, lastPart] = sliceItems(moreItems)
  })
</script>

{#each firstPart as tag}
  <div>{tag}</div>
{/each}

{#if moreItems.length > 2}
  <div 
    class="more-items"
    use:clickOutside
    on:click_outside={() => isShowMoreItems = false}
  >
    <div class="dots" on:click={() => isShowMoreItems = !isShowMoreItems}>...</div>

    {#if isShowMoreItems}
      <div class="more-items-modal">
        {#each lastPart as tag}
          <div>{tag}</div>
        {/each}
      </div>
    {/if}
  </div>
{/if}

<style lang="scss">
  .dots {
    cursor: pointer;
  }

  .more-items-modal {
    max-height: 120px;
    width: 173px;
    border-radius: 4px;
    padding: 8px;
    box-shadow: 0px 1px 12px 0px #30333D2E;
    box-sizing: border-box;
    z-index: 9999;
    position: absolute;
    margin-top: 4px;
    background-color: white;
    overflow-y: scroll;

    div {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>